import { handleActions } from 'redux-actions';
import { createSelector } from '@reduxjs/toolkit';
import {
  DOWNLOAD_SYSTEM_EVENTS,
  LOAD_SYSTEM_EVENTS,
} from './actions';
import { SYSTEM_EVENTS_MODULE, SYSTEM_MODULE } from '../../configs/moduleNames';
import { createLoadListReducer, createOperationStateReducer } from '../../utils/getCrudConfig';

const initialState = {
  loadingSystemEvents: false,
  systemEvents: [],
  systemEventsMeta: {},
  downloadingSystemEvents: false,
};

const reducer = handleActions({
  ...createLoadListReducer(SYSTEM_EVENTS_MODULE + LOAD_SYSTEM_EVENTS, 'systemEvents', 'loadingSystemEvents', []),
  ...createOperationStateReducer(SYSTEM_EVENTS_MODULE + DOWNLOAD_SYSTEM_EVENTS, 'downloadingSystemEvents'),
}, initialState);

export default reducer;

export const getSystemEventsData = createSelector(
  [state => state[SYSTEM_EVENTS_MODULE]],
  state => {
    const {
      loadingSystemEvents,
      systemEvents,
      systemEventsMeta,
    } = state;
    return {
      loadingSystemEvents,
      systemEvents,
      systemEventsMeta,
    };
  },
);
